Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Fluid = exports.Wrapper = exports.Flex = exports.Box = void 0;

var self_1 = require("./self");

var grid_reset_1 = require("./grid-reset");

var getExtraAttrs = function getExtraAttrs(props) {
  return {
    'aria-modal': props.ariaModal,
    rel: props.rel,
    role: props.role,
    onClick: props.onClick
  };
};

exports.Box = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, grid_reset_1.boxReset, 'box', extraAttrs, props.is || 'div');
};

exports.Flex = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, grid_reset_1.flexReset, 'flex', extraAttrs, props.is || 'div');
};

exports.Wrapper = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, grid_reset_1.wrapperReset, 'wrapper', extraAttrs, props.is || 'div');
};

exports.Fluid = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, grid_reset_1.fluidReset, 'fluid', extraAttrs, props.is || 'div');
};

exports.Container = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, grid_reset_1.containerReset, 'container', extraAttrs, props.is || 'div');
};